import { Routes } from '@angular/router';

import { CertificateVerificationComponent } from './views/certificate-verification/certificate-verification.component';

export const routes: Routes = [{ path: ':id/validate', component: CertificateVerificationComponent }];
